import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { defaultRedirect } from "helpers/constants";

const ProtectedLogin = ({ children }) => {
	const location = useLocation();
	const navigate = useNavigate();
	const me =
		JSON.parse(sessionStorage.getItem("me")) ||
		JSON.parse(localStorage.getItem("me"));

	// Check for both feedback and analytics URLs with siteAppId
	const isNavigatingFromSpecialPage =
		location.search.includes("siteAppId") &&
		(location.pathname.includes("feedback") ||
			location.search.includes("feedback") ||
			location.pathname.includes("/analytics/"));

	useEffect(() => {
		if (me && !isNavigatingFromSpecialPage) {
			const state = location.state || {};
			navigate(
				state?.from?.pathname
					? state.from.pathname
					: me.siteAppID
					? defaultRedirect[me.position.defaultPage]
					: "/app/me",
				{ state: { from: location } }
			);
		}
	}, [location, navigate, isNavigatingFromSpecialPage, me]);

	useEffect(() => {
		// for redirect url (esp. feedback route)
		if (!me?.position && isNavigatingFromSpecialPage) {
			navigate(`${location.search}`);
			return;
		}
	}, [me?.position, isNavigatingFromSpecialPage]);
	return children;
};

export default ProtectedLogin;
